import Dropdown from '../Dropdown';
import type { DropdownOption } from '../Dropdown';
import Pagination from '../Pagination';
import './TableFooter.css';

export interface TableFooterProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
  recordsDropdownName?: string;
  recordsPerPage?: number;
  recordsPerPageOptions?: DropdownOption<string>[];
  showPagination?: boolean;
  onRecordsPerPageChange?: (value: number) => void;
  'data-testid'?: string;
}

function TableFooter({
  currentPage,
  totalPages,
  onPageChange,
  className,
  recordsDropdownName = 'table-footer-records-per-page',
  recordsPerPage,
  recordsPerPageOptions,
  showPagination = true,
  onRecordsPerPageChange,
  'data-testid': dataTestId,
}: TableFooterProps) {
  const baseTestId = dataTestId ?? 'table-footer';
  const footerClassName = className ? `access-table-footer ${className}` : 'access-table-footer';
  const showRecordsDropdown = recordsPerPage !== undefined && recordsPerPageOptions && onRecordsPerPageChange;

  return (
    <div
      className={footerClassName}
      data-testid={baseTestId}>
      {showRecordsDropdown && (
        <Dropdown
          data-testid={`${baseTestId}-records-dropdown`}
          name={recordsDropdownName}
          options={recordsPerPageOptions}
          value={recordsPerPage.toString()}
          onChange={(value) => onRecordsPerPageChange(Number(value))}
        />
      )}
      {showPagination && (
        <div
          className='access-table-footer__pagination'
          data-testid={`${baseTestId}-pagination`}>
          <Pagination
            currentPage={currentPage}
            data-testid={`${baseTestId}-pagination-control`}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
}

export default TableFooter;
